module.exports = __webpack_public_path__ + "fonts/AudiType-ExtendedBoldItalic_4.03.eead71ca.woff2";